export default "__VITE_ASSET__Cvh2z3y___"